<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("signageurl", 1) }}
      </div>
      <div>
        <router-link class="btn-blue" to="signage-url"
          >{{ $tc("signageurl", 1) }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Cinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  @click="onSelectHandler('cinema', cinema, true)"
                  name="selectcinema"
                  id="selectcinema"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('cinemaSignageURL')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.Cinema.length == 0"
                >Please select cinema.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Signage.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("signage", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Signage"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(signage, signageIndex) in Signages"
                  :key="signageIndex"
                  @click="onSelectHandler('signage', signage, true)"
                  name="selectsignage"
                  id="selectsignage"
                  >{{ signage.st_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('selectsignage_SignageURL')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.Signage.length == 0"
                >Please select signage.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.SignageTemp.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("signage", 1) }}
              {{ $t("template") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.SignageTemp"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(signagetemp, signagetempIndex) in SignageTemplate"
                  :key="signagetempIndex"
                  @click="onSelectHandler('signagetemp', signagetemp)"
                  name="selectsignagetemp"
                  id="selectsignagetemp"
                  >{{ signagetemp.stemp_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('signageTemplate_signageURL')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.SignageTemp.length == 0"
                >Please select signage template.</span
              >
            </p>
          </div>
        </div>

        <div
          v-if="
            (selected.Signage && selected.Signage == 'Now Showing') ||
            selected.Signage == 'Next Change'
          "
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div class="dropdown-curve-container">
            <label :class="selected.Screen.length > 0 ? 'shift-up' : ''">{{
              $tc("screen", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Screen"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(screen, screenIndex) in screens"
                  :key="screenIndex"
                  @click="onSelectHandler('screen', screen)"
                  name="selectsignage"
                  id="selectsignage"
                  >{{ screen.screen_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="``" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.Screen.length == 0"
                >Please select screen.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                name="cpu_id"
                id="cpu_id"
                v-model="signageUrlDetails.su_cpu_id"
              />
              <label>CPU ID</label>
            </div>
            <!-- <Tooltip :title="$t('cupid_signageURL')" /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                disabled
                placeholder="."
                type="text"
                name="su_signage_url"
                id="su_signage_url"
                v-model="signageUrlDetails.su_signage_url"
              />
              <label>{{ $t("generated") }} URL</label>
            </div>
            <!-- <Tooltip :title="$t('generated_signageURL')" /> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && signageUrlDetails.su_signage_url.length == 0"
              >Please generate url.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="signageUrlDetails.su_is_active"
                  unchecked-value="N"
                  value="Y"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="signage-url"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import scheduleService from "@/services/scheduleService";
import signageServices from "@/services/signageService";
import moment from "moment";

export default {
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      isRoleID: true,
      btenable: false,
      selected: {
        Cinema: "",
        Signage: "",
        SignageTemp: "",
        Screen: "",
      },
      submitted: false,
      SignageUrlObj: {},
      signageUrlDetails: {
        su_id: null,
        su_name: "",
        cinema_id: "",
        signage_type_id: "",
        signage_template_id: "",
        screen_id: "",
        su_cpu_id: "",
        su_is_active: "Y",
        su_signage_url: "",
      },
      cine_id: "",
      cine_name: "",
      Cinemas: [],
      Signages: [],
      SignagesUrl: [],
      SignageTemplate: [],
      SignagesUrlCount: 0,
      screens: [],
      CinemasMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    const { id } = this.$route.query;
    if (id) {
      this.getEditDetails(id);
    } else {
      this.$router.go(-1);
    }
    // this.getCinemasList(obj);
    // this.getSignageTemplateList();
    // this.getSignagesCount();
    this.getSignageList();
  },
  methods: {
    getEditDetails(id) {
      console.log("id", id);
      signageServices
        .getSingleSignageUrlDetails({ su_id: id })
        .then((response) => {
          const { data } = response;
          console.log("DATA", data);
          if (data.status && data.Records.length > 0) {
            this.SignageUrlObj = data.Records[0];
            this.getCinemasList(this.SignageUrlObj.cine_id);
            this.onSelectHandler("signage", this.SignageUrlObj);
            this.getSignageTemplateList(this.SignageUrlObj.signage_template_id);
            this.onSelectHandler("screen", this.SignageUrlObj);
            Object.assign(this.signageUrlDetails, data.Records[0]);
          } else {
            this.$toasted.show(data.message);
            console.log("data.message", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onResetForm: function () {
      this.signageUrlDetails = {
        su_name: "",
        cinema_id: "",
        signage_type_id: "",
        signage_template_id: "",
        screen_id: "",
        su_cpu_id: "",
        su_is_active: "Y",
        su_signage_url: "",
      };
      this.selected = {
        Cinema: "",
        Signage: "",
        SignageTemp: "",
        Screen: "",
      };
    },
    getSignageTemplateList: function (st_id) {
      this.SignageTemplate = [];
      let payload = {
        tableName: "signage_templates",
        stemp_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.SignageTemplate = data.Records;
            if (st_id) {
              let SignageTemplateObj = this.SignageTemplate.find(
                (x) => x.stemp_id == st_id
              );
              if (SignageTemplateObj) {
                this.onSelectHandler("signagetemp", SignageTemplateObj);
              }
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            if (cine_id) {
              let CinemaObj = this.Cinemas.find((x) => x.cine_id == cine_id);
              if (CinemaObj) {
                this.onSelectHandler("cinema", CinemaObj);
              }
            }
          } else {
            // Show Errors
            this.$$toasted.show(data.message);
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getSignagesCount: function () {
      this.SignagesUrl = [];
      this.SignagesUrlCount = 0;
      let payload = {
        tableName: "signage_url",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.SignagesUrl = data.Records;
            this.SignagesUrlCount = data.Records.length + 1;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getSignageList: function () {
      this.Signages = [];
      let payload = {
        tableName: "ms_signage_types",
        st_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Signages = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getScreenList: function (CinemaID) {
      this.screens = [];
      // this.seat.ScreenID = 0;

      let payload = {
        cinema_id: CinemaID,
        SeatLayout: true,
      };
      scheduleService.GetScreens(payload).then((response) => {
        const { data } = response;
        console.log("data.status :", data.Records);
        // console.log("data.Records :", data.Records);
        if (data.status && data.Records.length > 0) {
          this.screens = data.Records;
          console.log("screens :", this.screens);
        } else {
          console.log("object :", data.Message);
        }
      });
      // .catch(error => {
      //   this.$toasted.show(
      //     "Sorry! Something went wrong. kindly contact your administrator"
      //   );
      // });
    },
    onGenerateUrl: function () {
      if (
        this.selected.Cinema &&
        this.selected.Cinema.length > 0 &&
        this.selected.Signage &&
        this.selected.Signage.length > 0
      ) {
        this.signageUrlDetails.su_signage_url =
          window.origin + "/#/signage-dynamic/" + this.SignagesUrlCount;
      } else {
        this.$toasted.show("You need to select Cinema and Signage First");
      }
    },
    _onGenerateUrl: function () {
      if (
        this.selected.Cinema &&
        this.selected.Cinema.length > 0 &&
        this.selected.Signage &&
        this.selected.Signage.length > 0
      ) {
        if (this.selected.Signage == "Coming Soon") {
          this.signageUrlDetails.su_signage_url =
            window.origin + "/#/signageComingSoon/" + this.SignagesUrlCount;
        } else if (this.selected.Signage == "Now Showing") {
          if (this.selected.Screen && this.selected.Screen.length > 0) {
            this.signageUrlDetails.su_signage_url =
              window.origin + "/#/signageNowShow/" + this.SignagesUrlCount;
          } else {
            this.$toasted.show("You need to select Screen");
          }
        } else if (this.selected.Signage == "Next Change") {
          if (this.selected.Screen && this.selected.Screen.length > 0) {
            this.signageUrlDetails.su_signage_url =
              window.origin + "/#/signageNextChange/" + this.SignagesUrlCount;
          } else {
            this.$toasted.show("You need to select Screen");
          }
        } else if (this.selected.Signage == "Latest Release") {
          this.signageUrlDetails.su_signage_url =
            window.origin + "/#/signageLatestRelease/" + this.SignagesUrlCount;
        } else if (this.selected.Signage == "Playing Today") {
          this.signageUrlDetails.su_signage_url =
            window.origin + "/#/signage/" + this.SignagesUrlCount;
        }
      } else {
        this.$toasted.show("You need to select Cinema and Signage First");
      }
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;

      if (
        this.signageUrlDetails.cinema_id.length == 0 ||
        this.signageUrlDetails.signage_type_id.length == 0 ||
        this.signageUrlDetails.signage_template_id.length == 0
      ) {
        return;
      }
      if (
        (this.selected.Signage == "Now Showing" &&
          this.signageUrlDetails.screen_id.length == 0) ||
        (this.selected.Signage == "Next Change" &&
          this.signageUrlDetails.screen_id.length == 0)
      ) {
        return;
      }
      if (this.signageUrlDetails.su_signage_url.length == 0) {
        return;
      } else {
        this.btenable = true;
        signageServices
          .UpdateSignageUrl({ ...this.signageUrlDetails })
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);

              this.onResetForm();
              if (redirect) {
                this.$router.push({
                  path: "/cinema-manager/signage-url",
                });
              }
            } else {
              this.$toasted.show(data.message);
            }
          });
      }
    },

    onSelectHandler: function (type, value, change = false) {
      if (type == "cinema") {
        this.signageUrlDetails.cinema_id = value.cine_id;
        this.selected.Cinema = value.cine_name;
        this.searchCinema = "";
        this.onSearchCinema();
        this.getScreenList(value.cine_id);
        if (change) {
          this.signageUrlDetails.screen_id = null;
          this.selected.Screen = "";
        }
      }
      if (type == "signage") {
        this.signageUrlDetails.signage_type_id = value.st_id;
        this.selected.Signage = value.st_name;
        if (change) {
          this.signageUrlDetails.screen_id = null;
          this.selected.Screen = "";
        }
      }
      if (type == "signagetemp") {
        this.signageUrlDetails.signage_template_id = value.stemp_id;
        this.selected.SignageTemp = value.stemp_name;
      }
      if (type == "screen") {
        console.log("screen :", screen);
        this.signageUrlDetails.screen_id = value.screen_id;
        this.selected.Screen = value.screen_name;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SignageUrl/editSignageUrl.vue